import { useMatches } from 'react-router';
export const useTypedMatches = () => {
    const matches = useMatches();
    return {
        matches,
        match: matches.slice(-1)?.[0],
    };
};
